<template>
  <div class="do-splash">
    <div class="do-splash__contanier">
      <DoLogo id="do-logo"></DoLogo>
    </div>
  </div>
</template>

<style scoped>
@import "../../assets/css/variables.css";

.do-splash {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1231231123;
  background: var(--gradient);
}

.do-splash__contanier {
  display: flex;
  height: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
}

#do-logo {
  max-width: 200px;
  /* animation: text-focus-in 0s cubic-bezier(0.55, 0.085, 0.68, 0.53) both !important; */
}

@keyframes text-focus-in {
  0% {
    filter: blur(12px);
    opacity: 0;
  }

  100% {
    filter: blur(0px);
    opacity: 1;
  }
}
</style>
<script>
import DoLogo from './DoLogo.vue'

export default {
  components: {DoLogo}
}
</script>



// WEBPACK FOOTER //
// DoSplash.vue?bd73b548